/* eslint-disable space-infix-ops */
/* eslint-disable dot-notation */
/* eslint-disable prefer-template */
/* eslint-disable indent */
/* eslint-disable keyword-spacing */
/* eslint-disable no-shadow */
/* eslint-disable space-before-function-paren */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import ScratchBlocks from 'openblock-blocks';
import {OLED_START, OLED_SETUP, INFRARED_SENSOR_START, button_start , bluetooth_start , example_star_war_setup, example_star_war_setup_function, example_soccer_player_def, example_soccer_player_setup,password_setup_1,password_setup_2,password_progress , Oled_start_code} from './code-data.js';

/**
 * Define code generators for demo blocks
 * @param {object} ScratchBlocks - The ScratchBlocks namespace
 */
export const defineDemoGenerators = ScratchBlocks => {
    // Demo Hello Block Generator
    ScratchBlocks.Arduino.demo_hello = function(block) {
        const message = ScratchBlocks.Arduino.valueToCode(block, 'MESSAGE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
        return `Serial.println(${message});\n`;
    };

    ScratchBlocks.Python.demo_hello = function(block) {
        const message = ScratchBlocks.Python.valueToCode(block, 'MESSAGE', ScratchBlocks.Python.ORDER_ATOMIC) || '""';
        return `print(${message})\n`;
    };

    // Demo Count Block Generator
    // ScratchBlocks.Arduino.demo_count = function(block) {
    //     const count = ScratchBlocks.Arduino.valueToCode(block, 'COUNT', ScratchBlocks.Arduino.ORDER_ATOMIC) || '0';
    //     return `for (int i = 0; i < ${count}; i++) {\n  // Demo Count\n}\n`;
    // };

    // ScratchBlocks.Python.demo_count = function(block) {
    //     const count = ScratchBlocks.Python.valueToCode(block, 'COUNT', ScratchBlocks.Python.ORDER_ATOMIC) || '0';
    //     return `for i in range(${count}):\n    # Demo Count\n    pass\n`;
    // };

    // Demo LED ON Block Generator
    ScratchBlocks.Arduino.demo_led_on = function(block) {
        const pin = '13';
        const pinDefineKey = `demo_led_pin_define_${pin}`;
        const pinModeKey = `demo_led_pinmode_${pin}`;

        // Add #define for pin number at the top of the code
        if (!ScratchBlocks.Arduino.definitions_[pinDefineKey]) {
            ScratchBlocks.Arduino.definitions_[pinDefineKey] = `#define LED_PIN ${pin}`;
        }
        if (!ScratchBlocks.Arduino.setups_[pinModeKey]) {
            ScratchBlocks.Arduino.setups_[pinModeKey] = `pinMode(LED_PIN, OUTPUT);`;
        }
        return `digitalWrite(LED_PIN, HIGH);\n`;
    };

    ScratchBlocks.Python.demo_led_on = function(block) {
        return `# LED ON\nprint("LED ON")\n`;
    };

    // Demo LED OFF Block Generator
    ScratchBlocks.Arduino.demo_led_off = function(block) {
        const pin = '13';
        const pinDefineKey = `demo_led_pin_define_${pin}`;
        const pinModeKey = `demo_led_pinmode_${pin}`;

        // Add #define for pin number at the top of the code
        if (!ScratchBlocks.Arduino.definitions_[pinDefineKey]) {
            ScratchBlocks.Arduino.definitions_[pinDefineKey] = `#define LED_PIN ${pin}`;
        }
        if (!ScratchBlocks.Arduino.setups_[pinModeKey]) {
            ScratchBlocks.Arduino.setups_[pinModeKey] = `pinMode(LED_PIN, OUTPUT);`;
        }
        return `digitalWrite(LED_PIN, LOW);\n`;
    };

    ScratchBlocks.Python.demo_led_off = function(block) {
        return `# LED OFF\nprint("LED OFF")\n`;
    };

    // Demo Delay Block Generator
    ScratchBlocks.Arduino.demo_delay = function(block) {
        const delay = ScratchBlocks.Arduino.valueToCode(block, 'DELAY', ScratchBlocks.Arduino.ORDER_ATOMIC) || '1000';
        return `delay(${delay});\n`;
    };

    ScratchBlocks.Python.demo_delay = function(block) {
        const delay = ScratchBlocks.Python.valueToCode(block, 'DELAY', ScratchBlocks.Python.ORDER_ATOMIC) || '1000';
        return `import time\ntime.sleep(${delay}/1000)\n`;
    };

    // Demo Show Message Block Generator
    // ScratchBlocks.Arduino.demo_show_message = function(block) {
    //     const message = ScratchBlocks.Arduino.valueToCode(block, 'MESSAGE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
    //     return `Serial.print("Demo: ");\nSerial.println(${message});\n`;
    // };

    // ScratchBlocks.Python.demo_show_message = function(block) {
    //     const message = ScratchBlocks.Python.valueToCode(block, 'MESSAGE', ScratchBlocks.Python.ORDER_ATOMIC) || '""';
    //     return `print(f"Demo: {${message}}")\n`;
    // };

    // Demo Clear Screen Block Generator
    ScratchBlocks.Arduino.demo_clear_screen = function(block) {
        return `Serial.clear();\n`;
    };

    ScratchBlocks.Python.demo_clear_screen = function(block) {
        return `import os\nos.system('cls' if os.name == 'nt' else 'clear')\n`;
    };

    // Demo Motor Start Block Generator
    ScratchBlocks.Arduino.demo_motor_start = function(block) {
        const motorPin1 = '5';
        const motorPin2 = '12';
        const motorPin3 = '6';
        const motorPin4 = '13';
        // define
        const pinDefineKey1 = `demo_motor_pin_define_${motorPin1}`;
        const pinDefineKey2 = `demo_motor_pin_define_${motorPin2}`;
        const pinDefineKey3 = `demo_motor_pin_define_${motorPin3}`;
        const pinDefineKey4 = `demo_motor_pin_define_${motorPin4}`;
        // pinMode
        const pinModeKey1 = `demo_motor_pinmode_${motorPin1}`;
        const pinModeKey2 = `demo_motor_pinmode_${motorPin2}`;
        const pinModeKey3 = `demo_motor_pinmode_${motorPin3}`;
        const pinModeKey4 = `demo_motor_pinmode_${motorPin4}`;
        // function
        const functionKey1 = `motor_M1_Tien`;
        const functionKey2 = `motor_M1_Lui`;
        const functionKey3 = `motor_M1_Dung`;
        const functionKey4 = `motor_M2_Tien`;
        const functionKey5 = `motor_M2_Lui`;
        const functionKey6 = `motor_M2_Dung`;
        const functionKey7 = `Motor_Tien_Len`;
        const functionKey8 = `Motor_Lui_Lai`;
        const functionKey9 = `Motor_Re_Trai`;
        const functionKey10 = `Motor_Re_Phai`;
        const functionKey11 = `Motor_Dung_Lai`;

        // Add #define for pin numbers at the top of the code
        if (!ScratchBlocks.Arduino.definitions_[pinDefineKey1]) {
            ScratchBlocks.Arduino.definitions_[pinDefineKey1] = `#define INM11 ${motorPin1}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[pinDefineKey2]) {
            ScratchBlocks.Arduino.definitions_[pinDefineKey2] = `#define INM12 ${motorPin2}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[pinDefineKey3]) {
            ScratchBlocks.Arduino.definitions_[pinDefineKey3] = `#define INM21 ${motorPin3}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[pinDefineKey4]) {
            ScratchBlocks.Arduino.definitions_[pinDefineKey4] = `#define INM22 ${motorPin4}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey1]) {
            ScratchBlocks.Arduino.definitions_[functionKey1] = `\nvoid motor_M1_Tien() {\n digitalWrite(INM11, 0);\n digitalWrite(INM12, 1);\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey2]) {
            ScratchBlocks.Arduino.definitions_[functionKey2] = `\nvoid motor_M1_Lui() {\n digitalWrite(INM11, 1);\n digitalWrite(INM12, 0);\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey3]) {
            ScratchBlocks.Arduino.definitions_[functionKey3] = `\nvoid motor_M1_Dung() {\n digitalWrite(INM11, 0);\n digitalWrite(INM12, 0);\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey4]) {
            ScratchBlocks.Arduino.definitions_[functionKey4] = `\nvoid motor_M2_Tien() {\n digitalWrite(INM21, 1);\n digitalWrite(INM22, 0);\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey5]) {
            ScratchBlocks.Arduino.definitions_[functionKey5] = `\nvoid motor_M2_Lui() {\n digitalWrite(INM21, 0);\n digitalWrite(INM22, 1);\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey6]) {
            ScratchBlocks.Arduino.definitions_[functionKey6] = `\nvoid motor_M2_Dung() {\n digitalWrite(INM21, 0);\n digitalWrite(INM22, 0);\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey7]) {
            ScratchBlocks.Arduino.definitions_[functionKey7] = `\nvoid Motor_Tien_Len() {\n motor_M1_Tien();\n motor_M2_Tien();\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey8]) {
            ScratchBlocks.Arduino.definitions_[functionKey8] = `\nvoid Motor_Lui_Lai() {\n motor_M1_Lui();\n motor_M2_Lui();\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey9]) {
            ScratchBlocks.Arduino.definitions_[functionKey9] = `\nvoid Motor_Re_Trai() {\n motor_M1_Dung();\n motor_M2_Tien();\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey10]) {
            ScratchBlocks.Arduino.definitions_[functionKey10] = `\nvoid Motor_Re_Phai() {\n motor_M1_Tien();\n motor_M2_Dung();\n}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[functionKey11]) {
            ScratchBlocks.Arduino.definitions_[functionKey11] = `\nvoid Motor_Dung_Lai() {\n motor_M1_Dung();\n motor_M2_Dung();\n}`;
        }
        if (!ScratchBlocks.Arduino.setups_[pinModeKey1]) {
            ScratchBlocks.Arduino.setups_[pinModeKey1] = `pinMode(INM11, OUTPUT);`;
        }
        if (!ScratchBlocks.Arduino.setups_[pinModeKey2]) {
            ScratchBlocks.Arduino.setups_[pinModeKey2] = `pinMode(INM12, OUTPUT);`;
        }
        if (!ScratchBlocks.Arduino.setups_[pinModeKey3]) {
            ScratchBlocks.Arduino.setups_[pinModeKey3] = `pinMode(INM21, OUTPUT);`;
        }
        if (!ScratchBlocks.Arduino.setups_[pinModeKey4]) {
            ScratchBlocks.Arduino.setups_[pinModeKey4] = `pinMode(INM22, OUTPUT);`;
        }
        return ``;
    };

    ScratchBlocks.Python.demo_motor_start = function(block) {
        return `# Khởi động động cơ\nprint("Motor started")\n`;
    };

    ScratchBlocks.Arduino.motor_custom = function(block) {
        const motor = block.getFieldValue('motor');
        const mode = block.getFieldValue('mode');
        return `motor_M${motor}_${mode}();\n`;
    };

    // Demo Robot Move Forward Block Generator
    ScratchBlocks.Arduino.demo_robot_forward = function(block) {
        return `Motor_Tien_Len();\n`;
    };

    ScratchBlocks.Python.demo_robot_forward = function(block) {
        return `# Robot tiến lên\nprint("Robot moving forward")\n`;
    };

    // Demo Robot Stop Block Generator
    ScratchBlocks.Arduino.demo_robot_stop = function(block) {
        return `Motor_Dung_Lai();\n`;
    };

    ScratchBlocks.Python.demo_robot_stop = function(block) {
        return `# Robot dừng lại\nprint("Robot stopped")\n`;
    };

    // Demo Robot Move Backward Block Generator
    ScratchBlocks.Arduino.demo_robot_back = function(block) {
        return `Motor_Lui_Lai();\n`;
    };

    ScratchBlocks.Python.demo_robot_back = function(block) {
        return `# Robot lùi lại\nprint("Robot moving backward")\n`;
    };

    // Demo Robot Turn Right Block Generator
    ScratchBlocks.Arduino.demo_robot_turn_right = function(block) {
        return `Motor_Re_Phai();\n`;
    };

    ScratchBlocks.Python.demo_robot_turn_right = function(block) {
        return `# Robot rẽ phải\nprint("Robot turning right")\n`;
    };

    // Demo Robot Turn Left Block Generator
    ScratchBlocks.Arduino.demo_robot_turn_left = function(block) {
        return `Motor_Re_Trai();\n`;
    };

    ScratchBlocks.Python.demo_robot_turn_left = function(block) {
        return `# Robot rẽ trái\nprint("Robot turning left")\n`;
    };

    // Demo OLED start block
    ScratchBlocks.Arduino.demo_OLED_start = function(block) {
        const startkey = 'demo_oled_startkey';
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = OLED_START;
        }
        return OLED_SETUP+`\n`;
    };

    ScratchBlocks.Python.demo_OLED_start = function(block) {
        return `# Robot rẽ trái\nprint("Robot turning left")\n`;
    };

    // Demo Robot Emotion Block Generator
    ScratchBlocks.Arduino.demo_robot_emotion = function(block) {
        const emotion = block.getFieldValue('EMOTION');
        return `print_emotion(${emotion});\n`;
    };

    // Demo robot display message on OLED
    ScratchBlocks.Arduino.demo_robot_oled_display = function(block) {
        const message = ScratchBlocks.Arduino.valueToCode(block, 'MESSAGE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
        const effect = block.getFieldValue('EFFECT');
        const size = ScratchBlocks.Arduino.valueToCode(block, 'TEXT_SIZE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const posX = ScratchBlocks.Arduino.valueToCode(block, 'POS_X', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"0"';
        const posY = ScratchBlocks.Arduino.valueToCode(block, 'POS_Y', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"0"';
        return `scrollText(${effect}, 5, ${message}, ${posX}, ${posY}, ${size});\n`;
    };

    // oled_text block
    ScratchBlocks.Arduino.oled_text = function(block) {
        const message = ScratchBlocks.Arduino.valueToCode(block, 'MESSAGE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
        const size = ScratchBlocks.Arduino.valueToCode(block, 'TEXT_SIZE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const posX = ScratchBlocks.Arduino.valueToCode(block, 'POS_X', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"0"';
        const posY = ScratchBlocks.Arduino.valueToCode(block, 'POS_Y', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"0"';
        return `oled_print_char(${message}, ${posX}, ${posY}, ${size});\n`;
    };

    // oled_number block
    ScratchBlocks.Arduino.oled_number = function(block) {
        const message = ScratchBlocks.Arduino.valueToCode(block, 'MESSAGE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
        const size = ScratchBlocks.Arduino.valueToCode(block, 'TEXT_SIZE', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const posX = ScratchBlocks.Arduino.valueToCode(block, 'POS_X', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"0"';
        const posY = ScratchBlocks.Arduino.valueToCode(block, 'POS_Y', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"0"';
        return `oled_print_number(${message}, ${posX}, ${posY}, ${size});\n`;
    };

    // demo buzzer start block
    ScratchBlocks.Arduino.demo_buzzer_start = function(block) {
        const setupKey = 'demo_buzzer_setup';
        if (!ScratchBlocks.Arduino.definitions_[setupKey]) {
            ScratchBlocks.Arduino.definitions_[setupKey] = `#include <TimerFreeTone.h>\nint speakerPin = 11;\n`;
            ScratchBlocks.Arduino.setups_[setupKey] = `pinMode(speakerPin,OUTPUT);`;
        }
        return ``;
    };

    // demo alarm block
    ScratchBlocks.Arduino.demo_buzzer_alarm = function(block) {
        return `for(int coi=0;coi<5;coi++){\n TimerFreeTone(speakerPin,262,0.25*1000);\n delay(0.25*1000);\n TimerFreeTone(speakerPin,262,0.25*1000);\n delay(0.25*1000);\n TimerFreeTone(speakerPin,262,0.25*1000);\n delay(0.25*1000);\n TimerFreeTone(speakerPin,262,0.25*1000);\n delay(0.25*1000);\n}\n`;
    };

    // demo warning danger block
    ScratchBlocks.Arduino.demo_warining_danger = function(block) {
        return `for(int nguyhiem=0;nguyhiem<5;nguyhiem++){\n TimerFreeTone(speakerPin,523,0.25*1000);\n delay(0.25*1000);\n TimerFreeTone(speakerPin,65,0.25*1000);\n delay(0.25*1000);\n}\n`;
    };

    // demo turn off buzzer block
    ScratchBlocks.Arduino.demo_turn_off_buzzer = function(block) {
        return `digitalWrite(speakerPin, LOW);\n`;
    };

    // vibration_start block
    ScratchBlocks.Arduino.vibration_start = function(block) {
        const startkey = 'Vibration_sensor';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_['Vibration_sensor'] = `#define Vi_Sensor A3\n`;
            ScratchBlocks.Arduino.setups_['Vibration_sensor'] = `pinMode(Vi_Sensor,INPUT);\n`;
        }
        return ``;
    };

    // vibration_value block
    ScratchBlocks.Arduino.vibration_value = function(block) {
        return [`analogRead(Vi_Sensor)`,ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // demo Vibration sensor block
    ScratchBlocks.Arduino.demo_vibration_sensor = function(block) {
        const startkey = 'demo_vibration_startkey';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = OLED_START;
            ScratchBlocks.Arduino.definitions_['Vibration_sensor'] = `#define Vi_Sensor A3\n`;
            ScratchBlocks.Arduino.setups_['Vibration_sensor'] = `pinMode(Vi_Sensor,INPUT);\n`;
            ScratchBlocks.Arduino.loops_['Vibration_sensor'] = `int sensorValue = analogRead(Vi_Sensor);\n Serial.println(sensorValue);\n delay(1000);\n`;
        }
        return OLED_SETUP+`scrollText(Left2Right, 5, String(analogRead(Vi_Sensor)), 0, 0, 3);\n`;
    };

    // solar_start block
    ScratchBlocks.Arduino.solar_start = function(block) {
        const startkey = 'demo_solar_startkey';
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_['solar_sensor'] = `int cambienanhsangA0 = A0;`;
            ScratchBlocks.Arduino.setups_['solar_sensor'] = `Serial.begin(9600);\n`;
        }
        return ``;
    };

    // solar_value block
    ScratchBlocks.Arduino.solar_value = function(block) {
        return [`map(analogRead(cambienanhsangA0), 0, 1023, 100, 0)`,ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // demo solar sensor block
    ScratchBlocks.Arduino.demo_solar_sensor = function(block) {
        const startkey = 'demo_solar_startkey';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_['solar_sensor'] = `#define solar_Sensor A0`;
            ScratchBlocks.Arduino.loops_['solar_sensor'] = `int sensorValue = analogRead(solar_Sensor);\n  int dosang = map(sensorValue, 0, 1023, 0, 100);\n  Serial.println(dosang);\n  delay(1000);\n`;
        }
        return ``;
    };

    // Irsensor block
    ScratchBlocks.Arduino.Irsensor_block = function(block) {
        const startkey = 'irsensor_startkey';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        const AnalogPin = block.getFieldValue('AnalogPin');
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `byte irSensorPin${AnalogPin} = ${AnalogPin};\nint sensorValue${AnalogPin} = 0;\n\nunsigned int Object${AnalogPin}(){\n sensorValue${AnalogPin} = digitalRead(irSensorPin${AnalogPin});\n return sensorValue${AnalogPin};\n}`;
            ScratchBlocks.Arduino.setups_[startkey] = `pinMode(irSensorPin${AnalogPin}, INPUT);`;
        }
        return ``;
    };

    // detect object block
    ScratchBlocks.Arduino.detect_object = function(block) {
        const AnalogPin = block.getFieldValue('AnalogPin');
        return [`Object${AnalogPin}() == 1`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // infrared_sensor_start block
    ScratchBlocks.Arduino.infrared_sensor_start = function(block) {
        const startkey = 'infrared_sensor_startkey';
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = INFRARED_SENSOR_START;
            ScratchBlocks.Arduino.setups_[startkey] = `irrecv.enableIRIn();`;
        }
        return ``;
    };

    // infrared_sensor_button block
    ScratchBlocks.Arduino.infrared_sensor_button = function(block) {
        const button = block.getFieldValue('ButtonSelect');
        return [`results.value == IR_REMOTE_${button}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // infrared_sensor_test block
    ScratchBlocks.Arduino.infrared_sensor_test = function(block) {
        return `if(irrecv.decode(&results)){\n irrecv.resume();\n delay(0.25 * 1000);\n}\n`;
    };

    // button_start block
    ScratchBlocks.Arduino.button_start = function(block) {
        const startkey = 'button_start_startkey';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = button_start;
            ScratchBlocks.Arduino.setups_[startkey] = `pinMode(BUTTON_LEFT, INPUT_PULLUP);\n  pinMode(BUTTON_RIGHT, INPUT_PULLUP);`;
        }
        return ``;
    };

    // right_button_value block
    ScratchBlocks.Arduino.right_button_value = function(block) {
        const value = ScratchBlocks.Arduino.valueToCode(block, 'button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return [`Times_Button_7 == 1 && Count_Button_7 == ${value}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // left_button_value block
    ScratchBlocks.Arduino.left_button_value = function(block) {
        const value = ScratchBlocks.Arduino.valueToCode(block, 'button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return [`Times_Button_8 == 1 && Count_Button_8 == ${value}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // setting_toggle_button block
    ScratchBlocks.Arduino.setting_toggle_button = function(block) {
        const right_value = ScratchBlocks.Arduino.valueToCode(block, 'right_button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const left_value = ScratchBlocks.Arduino.valueToCode(block, 'left_button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return `  Number_Button_7 = ${right_value};
  if(Count_Button_7 == Number_Button_7){
    Count_Button_7 = 0;
  }
  Number_Button_8 = ${left_value};
  if(Count_Button_8 == Number_Button_8){
    Count_Button_8 = 0;
  }
  if(button_debounce(BUTTON_RIGHT) == 1){
    Count_Button_7++;;
    Times_Button_7 = 1;
  } else {
    Times_Button_7 = 0;
  }
  if(button_debounce(BUTTON_LEFT) == 1){
    Count_Button_8++;
    Times_Button_8 = 1;
  } else {
    Times_Button_8 = 0;
  }\n`;
    };

    // bluetooth_start block
    ScratchBlocks.Arduino.bluetooth_start = function(block) {
        const startkey = 'bluetooth_start_startkey';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = bluetooth_start;
            ScratchBlocks.Arduino.setups_[startkey] = `ble_at09.begin(9600);`;
        }
        return ``;
    };

    // bluetooth_test block
    ScratchBlocks.Arduino.bluetooth_test = function(block) {
        const startkey = 'bluetooth_test_startkey';
        return `Connect();\n`;
    };

    // signal_from block
    ScratchBlocks.Arduino.signal_from = function(block) {
        const switch_select = block.getFieldValue('switch');
        const mode = block.getFieldValue('mode');
        return [`LeeString == "switch${switch_select}:${mode}"`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // send_text block
    ScratchBlocks.Arduino.send_text = function(block) {
        const message = ScratchBlocks.Arduino.valueToCode(block, 'message', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
        return `dataSend = ${message};\nble_at09.println(dataSend);\n`;
    };

    // dimmer_value block
    ScratchBlocks.Arduino.dimmer_value = function(block) {
        return [`chuyen_doi_dimmer(LeeString)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // sinal_from_gamepad block
    ScratchBlocks.Arduino.sinal_from_gamepad = function(block) {
        const gamepad_value = block.getFieldValue('gamepad_value');
        return [`LeeString == "gamepad:${gamepad_value}"`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // signal_from_void_controll block
    ScratchBlocks.Arduino.signal_from_void_controll = function(block) {
        const void_controll_value = ScratchBlocks.Arduino.valueToCode(block, 'void_controll_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
        return [`voiceMessage == ${void_controll_value}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // color_picker_value block
    ScratchBlocks.Arduino.color_picker_value = function(block) {
        return [`chuyen_doi_mau_sac(LeeString)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // signal_from_terminal block
    ScratchBlocks.Arduino.signal_from_terminal = function(block) {
        const Terminal_value = ScratchBlocks.Arduino.valueToCode(block, 'Terminal_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '""';
        return [`LeeString == ${Terminal_value}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // example_star_war block
    ScratchBlocks.Arduino.example_star_war = function(block) {
        const startkey = 'example_star_war_startkey';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = example_star_war_setup;
        }
        if (!ScratchBlocks.Arduino.setups_[startkey]) {
            ScratchBlocks.Arduino.setups_[startkey] = example_star_war_setup_function;
        }
        return ``;
    };

    // example_soccer_player block
    ScratchBlocks.Arduino.example_soccer_player = function(block) {
        const startkey = 'example_soccer_player_startkey';
        if(!ScratchBlocks.Arduino.setups_['serial']) {
            ScratchBlocks.Arduino.setups_['serial'] = `Serial.begin(9600);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = example_soccer_player_def;
        }
        if (!ScratchBlocks.Arduino.setups_[startkey]) {
            ScratchBlocks.Arduino.setups_[startkey] = example_soccer_player_setup;
        }
        return ``;
    };

    // led_start block
    ScratchBlocks.Arduino.led_start = function(block) {
        const startkey = 'led_start_startkey';
        const led = block.getFieldValue('led_pin');
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `byte ledPin1${led} = 1${led};\nint intsd;`;
        }
        if (!ScratchBlocks.Arduino.setups_[startkey]) {
            ScratchBlocks.Arduino.setups_[startkey] = `pinMode(1${led}, OUTPUT);\n  digitalWrite(ledPin1${led}, LOW);`;
        }
        return ``;
    };

    // led_mode_on_pin block
    ScratchBlocks.Arduino.led_mode_on_pin = function(block) {
        const mode = block.getFieldValue('mode');
        const pin = block.getFieldValue('pin');
        return `digitalWrite(ledPin1${pin}, ${mode});\n`;
    };

    // led_on_effect block
     ScratchBlocks.Arduino.led_on_effect = function(block) {
        const time = ScratchBlocks.Arduino.valueToCode(block, 'time', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const pin = block.getFieldValue('pin');
        return `for (intsd = 1;intsd<=255;intsd = intsd + 25.5/(${time})) {\n   analogWrite(ledPin1${pin}, intsd);\n   delay(100);\n   if (intsd>=250) {\n    break;\n  }\n }\n`;
    };

    // led_off_effect block
     ScratchBlocks.Arduino.led_off_effect = function(block) {
        const time = ScratchBlocks.Arduino.valueToCode(block, 'time', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const pin = block.getFieldValue('pin');
        return `for (intsd = 255;intsd>=0;intsd = intsd - 25.5/(${time})) {\n   analogWrite(ledPin1${pin}, intsd);\n   delay(100);\n   if (intsd<=5) {\n    digitalWrite(11, 0);\n    break;\n  }\n }\n`;
    };

    // led_on_intensity block
     ScratchBlocks.Arduino.led_on_intensity = function(block) {
        const intensity = ScratchBlocks.Arduino.valueToCode(block, 'intensity', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const pin = block.getFieldValue('pin');
        return `analogWrite(ledPin1${pin},map(${intensity},0,100,0,255));\n`;
    };

    // timer_setup block
    ScratchBlocks.Arduino.timer_setup = function(block) {
        const startkey = 'timer_start_startkey';
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `unsigned long thoigianhoc = 0;`;
        }
        return ``;
    };

    // timer_limit block
    ScratchBlocks.Arduino.timer_limit = function(block) {
        const time = ScratchBlocks.Arduino.valueToCode(block, 'time', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return `if(thoigianhoc == ${time}){\n thoigianhoc = 0;\n}\nelse{\n thoigianhoc++;\n delay(1 * 1000);\n}\n`;
    };

    // timer_value block
    ScratchBlocks.Arduino.timer_value = function(block) {
        const time = ScratchBlocks.Arduino.valueToCode(block, 'time', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return [`thoigianhoc == ${time}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // password_setup block
    ScratchBlocks.Arduino.password_setup = function(block) {
        const pass1 = ScratchBlocks.Arduino.valueToCode(block, 'pass1', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const pass2 = ScratchBlocks.Arduino.valueToCode(block, 'pass2', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const pass3 = ScratchBlocks.Arduino.valueToCode(block, 'pass3', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const pass4 = ScratchBlocks.Arduino.valueToCode(block, 'pass4', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const pin = block.getFieldValue('pin');
        const startkey = 'password_setup_startkey';
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = password_setup_1 + `IRrecv irrecv(${pin});`+ password_setup_2+ `bool check_password(int arr[]){\n if(arr[0] == ${pass1}){\n  if(arr[1] == ${pass2}){\n   if(arr[2] == ${pass3}){\n    if(arr[3] == ${pass4}){\n     return true;\n    } else return false;\n   } else return false;\n  } else return false;\n } else return false;\n}\n`;
            ScratchBlocks.Arduino.setups_[startkey] = `irrecv.enableIRIn();\n if (!display.begin(SSD1306_SWITCHCAPVCC, SCREEN_ADDRESS)) {\n  Serial.println(F("SSD1306 allocation failed"));\n  for (;;);\n }\n else{\n }\n eye_blink();\n`;
        }
        return ``;
    };

    // progress_password block
    ScratchBlocks.Arduino.progress_password = function(block) {
        return password_progress;
    };

    // password_true block 
    ScratchBlocks.Arduino.password_true = function(block) {
        return [`Result_Password == 1`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // password_wrong block
    ScratchBlocks.Arduino.password_wrong = function(block) {
        return [`Result_Password == 0`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // password_done block
    ScratchBlocks.Arduino.password_done = function(block) {
        return `Result_Password = 2;\n`;
    };

    // esp32_test_blocks block
    ScratchBlocks.Arduino.esp32_test_blocks = function(block) {
        const startkey = 'esp32_test_startkey';
        const pin = block.getFieldValue('PORT');
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.setups_[startkey] = `int esp32_test_pin = ${pin};\n  pinMode(esp32_test_pin, OUTPUT);`;
        }
        return ``;
    };

    // esp32_test_adc_blocks block
    ScratchBlocks.Arduino.esp32_test_adc = function(block) {
        const startkey = 'esp32_adc_startkey';
        const pin = block.getFieldValue('PORT');
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.setups_[startkey] = `int esp32_adc_pin = ${pin};\n  pinMode(esp32_adc_pin, OUTPUT);`;
        }
        return ``;
    };

    // esp32_rgb_sensor_start block
    ScratchBlocks.Arduino.esp32_rgb_sensor_start = function(block) {
        const wire_h_key = 'wire_h_key';
        const Adafruit_TCS34725_key = 'Adafruit_TCS34725_key';
        const i2c_startkey = 'esp32_i2c_startkey';
        const startkey = 'esp32_rgb_sensor_startkey';
        const pin = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.includes_[wire_h_key]) {
            ScratchBlocks.Arduino.includes_[wire_h_key] = `#include <Wire.h>`;
        }
        if(!ScratchBlocks.Arduino.includes_[Adafruit_TCS34725_key]) {
            ScratchBlocks.Arduino.includes_[Adafruit_TCS34725_key] = `#include <Adafruit_TCS34725.h>`;
        }
        const baurateKey = 'esp32_bauratekey';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[i2c_startkey]) {
            ScratchBlocks.Arduino.definitions_[i2c_startkey] = `
#define I2C_SDA0 13
#define I2C_SCL0 14
#define I2C_SDA1 15
#define I2C_SCL1 16

#define TCA_ADDR 0x70
void tcaSelect(TwoWire &i2c, uint8_t ch) {
  if (ch > 7) return;

  i2c.beginTransmission(TCA_ADDR);
  i2c.write(1 << ch);
  i2c.endTransmission();
}
`;
            ScratchBlocks.Arduino.setups_[i2c_startkey] = `Wire.begin(I2C_SDA0, I2C_SCL0);\n  Wire1.begin(I2C_SDA1, I2C_SCL1);`;
        }
        if(!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `
${pin}
#define PROXIMITY_THRESHOLD 500
#define MAU_KHONG_XAC_DINH 0
#define MAU_DO 1
#define MAU_XANH_LA 2
#define MAU_XANH_DUONG 3
Adafruit_TCS34725 tcs_rgb_sensor(
  TCS34725_INTEGRATIONTIME_154MS,
  TCS34725_GAIN_4X
);
uint16_t rawR, rawG, rawB, rawC;
void docGiaTriMau() {
  if (TCA_BUS_TCS3472 == 0) {
    tcaSelect(Wire, TCA_CHANNEL_TCS3472);
  } else {
    tcaSelect(Wire1, TCA_CHANNEL_TCS3472);
  }
  tcs_rgb_sensor.getRawData(&rawR, &rawG, &rawB, &rawC);
}
int phanTichMau() {
  if (rawC < PROXIMITY_THRESHOLD) {
    return MAU_KHONG_XAC_DINH;
  }
  if (rawR > rawG && rawR > rawB) {
    return MAU_DO;
  }
  else if (rawG > rawR && rawG > rawB) {
    return MAU_XANH_LA;
  }
  else if (rawB > rawR && rawB > rawG) {
    return MAU_XANH_DUONG;
  }
  return MAU_KHONG_XAC_DINH;
}
int gia_tri_mau(int color){
    switch(color){
        case MAU_DO:
            return rawR;
        case MAU_XANH_LA:
            return rawG;
        case MAU_XANH_DUONG:
            return rawB;
        default:
            return 0;
    }
}`;
            ScratchBlocks.Arduino.setups_[startkey] = `if (TCA_BUS_TCS3472 == 0) {
    tcaSelect(Wire, TCA_CHANNEL_TCS3472);
    if (!tcs_rgb_sensor.begin(TCS34725_ADDRESS, &Wire)) {
        Serial.println("Khong tim thay TCS tren Wire");
    }
  } else {
        tcaSelect(Wire1, TCA_CHANNEL_TCS3472);
        if (!tcs_rgb_sensor.begin(TCS34725_ADDRESS, &Wire1)) {
            Serial.println("Khong tim thay TCS tren Wire1");
        }
    }`;
        }
        return ``;
    };

    // esp32_color_check block
    ScratchBlocks.Arduino.esp32_color_check = function(block) {
        const color = block.getFieldValue('color_value');
        return [`phanTichMau() == ${color}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_rgb_value block
    ScratchBlocks.Arduino.esp32_rgb_value = function(block) {
        return `docGiaTriMau();\n`;
    };

    // esp32_rgb_color_value block
    ScratchBlocks.Arduino.esp32_rgb_color_value = function(block) {
        const color_value = block.getFieldValue('color_value');
        return [`gia_tri_mau(${color_value})`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_rgb_read_color_value block
    ScratchBlocks.Arduino.esp32_rgb_read_color_value = function(block) {
        const value = ScratchBlocks.Arduino.valueToCode(block, 'value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '1';
        return `Serial.println(${value});\n`;
    };

    // esp32_VL6180X_start block
    ScratchBlocks.Arduino.esp32_VL6180X_start = function(block) {
        const wire_h_key = 'wire_h_key';
        const VL6180X_key = 'VL6180X_key';
        const i2c_startkey = 'esp32_i2c_startkey';
        const pin = block.getFieldValue('PORT');
        const port = block.getField('PORT').getText();
        const startkey = 'esp32_VL6180X_startkey';
        const initkey = 'esp32_VL6180X_initkey';
        const startkey_port = 'esp32_VL6180X_startkey_' + port;
        if(!ScratchBlocks.Arduino.includes_[wire_h_key]) {
            ScratchBlocks.Arduino.includes_[wire_h_key] = `#include <Wire.h>`;
        }
        if(!ScratchBlocks.Arduino.includes_[VL6180X_key]) {
            ScratchBlocks.Arduino.includes_[VL6180X_key] = `#include <VL6180X.h>`;
        }
        const baurateKey = 'esp32_bauratekey';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[i2c_startkey]) {
            ScratchBlocks.Arduino.definitions_[i2c_startkey] = `#define I2C_SDA0 13
#define I2C_SCL0 14
#define I2C_SDA1 15
#define I2C_SCL1 16

#define TCA_ADDR 0x70
void tcaSelect(TwoWire &i2c, uint8_t ch) {
  if (ch > 7) return;

  i2c.beginTransmission(TCA_ADDR);
  i2c.write(1 << ch);
  i2c.endTransmission();
}
`;  
            ScratchBlocks.Arduino.setups_[i2c_startkey] = `Wire.begin(I2C_SDA0, I2C_SCL0);\n  Wire1.begin(I2C_SDA1, I2C_SCL1);`;
        }
        if(!ScratchBlocks.Arduino.definitions_[initkey]) {
            ScratchBlocks.Arduino.definitions_[initkey] = `void initSensor_VL6180(VL6180X &sensor, uint8_t bus, uint8_t channel) {
  if (bus == 0) {
    sensor.setBus(&Wire);
    tcaSelect(Wire, channel);
  }
  else if (bus == 1) {
    sensor.setBus(&Wire1);
    tcaSelect(Wire1, channel);
  }
  sensor.init();
  sensor.configureDefault();
  sensor.setTimeout(500);
}

int16_t readDistance_VL6180(VL6180X &sensor, uint8_t bus, uint8_t channel) {
  if (bus == 0) {
    tcaSelect(Wire, channel);
  }
  else if (bus == 1) {
    tcaSelect(Wire1, channel);
  }
  uint8_t raw = sensor.readRangeSingleMillimeters();

  if (sensor.timeoutOccurred() || raw == 255) {
    return -1;
  }
  if (raw > 200) {
    return -1;
  }
  return (int16_t)raw;
}`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey_port]) {
            ScratchBlocks.Arduino.definitions_[startkey_port] = `${pin}`;
            ScratchBlocks.Arduino.setups_[startkey_port] = `initSensor_VL6180(sensor${port}, VL6180_SENSOR${port}_BUS, VL6180_SENSOR${port}_CHANNEL);`;
        }
        
        return ``;
    };

    // esp32_VL6180X_value block
    ScratchBlocks.Arduino.esp32_VL6180X_value = function(block) {
        const port = block.getField('PORT').getText();
        return [`readDistance_VL6180(sensor${port}, VL6180_SENSOR${port}_BUS,VL6180_SENSOR${port}_CHANNEL)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_VL6180X_read_distance_value block
    ScratchBlocks.Arduino.esp32_VL6180X_read_distance_value = function(block) {
        const value = ScratchBlocks.Arduino.valueToCode(block, 'value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '1';
        return `if (${value} == -1) {
  Serial.println("VL6180X: không nằm trong phạm vi đo!");  }
else {
    Serial.print("Khoảng cách: ");
    Serial.print(${value});
    Serial.println(" mm");
}\n`;
    };

    // esp32_TCRT5000_start block
    ScratchBlocks.Arduino.esp32_TCRT5000_start = function(block) {
        const baurateKey = 'esp32_bauratekey';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        const port = block.getFieldValue('PORT');
        const postition = block.getFieldValue('POSITION');
        const startkey_port = 'esp32_TCRT5000_startkey_' + port;
        const value = ScratchBlocks.Arduino.valueToCode(block, 'value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '2500';
        if (!ScratchBlocks.Arduino.definitions_[startkey_port]) {
            ScratchBlocks.Arduino.definitions_[startkey_port] = `const int pinA0_TCRT5000_${postition} = ${port};
const int nguongPhatHien_TCRT5000_${postition} = ${value};

void thietLapCamBienIR_TCRT5000_${postition}() {
  pinMode(pinA0_TCRT5000_${postition}, INPUT);
  analogReadResolution(12);
}
  
bool xulikhongcachAnalog_TCRT5000_${postition}() {
  int giaTriAnalog = analogRead(pinA0_TCRT5000_${postition});
  if (giaTriAnalog < nguongPhatHien_TCRT5000_${postition}) {
    return true;
  } else {
    return false;
  }
}`;
            ScratchBlocks.Arduino.setups_[startkey_port] = `thietLapCamBienIR_TCRT5000_${postition}();`;
        }
        return ``;
    };

    // esp32_TCRT5000_check block
    ScratchBlocks.Arduino.esp32_TCRT5000_check = function(block) {
        const postition = block.getFieldValue('POSITION');
        return [`xulikhongcachAnalog_TCRT5000_${postition}() == true`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_SR602_start block
    ScratchBlocks.Arduino.esp32_SR602_start = function(block) {
        const startkey = 'esp32_SR602_startkey';
        const baurateKey = 'esp32_bauratekey';
        const port = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `#define PIN_RS602 ${port}\n
bool readsensor_SR602() {
  int status_SR602 = digitalRead(PIN_RS602);
  
  if (status_SR602 == HIGH) {
    return true;
  } else {
    return false;
  }
}`;
            ScratchBlocks.Arduino.setups_[startkey] = 'pinMode(PIN_RS602, INPUT_PULLDOWN);';
        }
        return ``;
    };

    // esp32_SR602_check block
    ScratchBlocks.Arduino.esp32_SR602_check = function(block) {
        return [`readsensor_SR602() == true`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_HW484_start block
    ScratchBlocks.Arduino.esp32_HW484_start = function(block) {
        const startkey = 'esp32_HW484_startkey';    
        const baurateKey = 'esp32_bauratekey';
        const port = block.getFieldValue('PORT');
        const value = ScratchBlocks.Arduino.valueToCode(block, 'value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '2000';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `${port}
#define THRESHOLD_FIRE_HW484 ${value}

bool Check_HW484(int value) {
  return value < THRESHOLD_FIRE_HW484;
}`;
            ScratchBlocks.Arduino.setups_[startkey] = `analogReadResolution(12);\n  analogSetAttenuation(ADC_11db);`;
        }
        return ``;
    };

    // esp32_HW484_check block
    ScratchBlocks.Arduino.esp32_HW484_check = function(block) {
        return [`Check_HW484(analogRead(FLAME_HW484_A0)) == true`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_MQ2_Smoke_start block
    ScratchBlocks.Arduino.esp32_MQ2_Smoke_start = function(block) {
        const startkey = 'esp32_MQ2_Smoke_startkey';    
        const baurateKey = 'esp32_bauratekey';
        const port = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.includes_[startkey] = `#include <MQUnifiedsensor.h>`;
            ScratchBlocks.Arduino.definitions_[startkey] = `#define Board ("ESP32-S3")
#define PinA0_MQ2 (${port})
#define Type ("MQ-2")
#define Voltage_Resolution (3.3)
#define ADC_Bit_Resolution (12)
#define RatioMQ2CleanAir_MQ2FlyingFish (9.83)

float lpg_MQ2FlyingFish = 0, smoke_MQ2FlyingFish = 0;
String status_MQ2FlyingFish = "";

MQUnifiedsensor MQ2FlyingFish(Board, Voltage_Resolution, ADC_Bit_Resolution, PinA0_MQ2, Type);

void StartSensor_MQ2FlyingFish() {
  MQ2FlyingFish.setRegressionMethod(1);
  MQ2FlyingFish.init();
  float calcR0 = 0;
  for (int i = 1; i <= 10; i++) {
    MQ2FlyingFish.update();
    calcR0 += MQ2FlyingFish.calibrate(RatioMQ2CleanAir_MQ2FlyingFish);
    delay(500);
  }
  MQ2FlyingFish.setR0(calcR0 / 10);
  if (isinf(calcR0) || calcR0 == 0) {
    while (1);
  }
}
  
void MeasureAirCondition_MQ2FlyingFish() {
  MQ2FlyingFish.update();
  MQ2FlyingFish.setA(574.25); MQ2FlyingFish.setB(-2.222);
  lpg_MQ2FlyingFish = MQ2FlyingFish.readSensor();
  MQ2FlyingFish.setA(36974); MQ2FlyingFish.setB(-3.109); 
  smoke_MQ2FlyingFish = MQ2FlyingFish.readSensor();
}

void CheckAirStatus_MQ2FlyingFish() {
  if (lpg_MQ2FlyingFish > 1000 || smoke_MQ2FlyingFish > 500) {
    status_MQ2FlyingFish = "NGUY HIEM (ALARM)";
  } 
  else if (lpg_MQ2FlyingFish > 400 || smoke_MQ2FlyingFish > 150) {
    status_MQ2FlyingFish = "CANH BAO (WARNING)";
  } 
  else {
    status_MQ2FlyingFish = "TRONG LANH (SAFE)";
  }
}
  
bool Status(String value) {
    MeasureAirCondition_MQ2FlyingFish();
    CheckAirStatus_MQ2FlyingFish();
    return status_MQ2FlyingFish == value;
}`;
            ScratchBlocks.Arduino.setups_[startkey] = `StartSensor_MQ2FlyingFish();`;
        }
        return ``;
    };

    // esp32_MQ2_Smoke_check block
    ScratchBlocks.Arduino.esp32_MQ2_Smoke_check = function(block) {
        const value = block.getFieldValue('value');
        return [`Status("${value}")`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_BME680_start block
    ScratchBlocks.Arduino.esp32_BME680_start = function(block) {
        const startkey = 'esp32_BME680_startkey';    
        const wire_h_key = 'wire_h_key';
        const Adafruit_BME680_key = 'BME680_H_key';
        const i2c_startkey = 'esp32_i2c_startkey';
        const Adafruit_Sensor_key = 'Adafruit_Sensor_H_key';
        const baurateKey = 'esp32_bauratekey';
        const port = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if(!ScratchBlocks.Arduino.includes_[wire_h_key]) {
            ScratchBlocks.Arduino.includes_[wire_h_key] = `#include <Wire.h>`;
        }
        if(!ScratchBlocks.Arduino.includes_[Adafruit_BME680_key]) {
            ScratchBlocks.Arduino.includes_[Adafruit_BME680_key] = `#include <Adafruit_BME680.h>`;
        }
        if(!ScratchBlocks.Arduino.includes_[Adafruit_Sensor_key]) {
            ScratchBlocks.Arduino.includes_[Adafruit_Sensor_key] = `#include <Adafruit_Sensor.h>`;
        }
        if (!ScratchBlocks.Arduino.definitions_[i2c_startkey]) {
            ScratchBlocks.Arduino.definitions_[i2c_startkey] = `
#define I2C_SDA0 42
#define I2C_SCL0 02
#define TCA_ADDR 0x70
#define TCA_ADDR_2 0x74

void disableTCA() {
  Wire.beginTransmission(TCA_ADDR);
  Wire.write(0x00);
  Wire.endTransmission();
  Wire.beginTransmission(TCA_ADDR_2);
  Wire.write(0x00);
  Wire.endTransmission();
  delay(2);
}

void tcaSelect(uint8_t tca_addr, uint8_t ch) {
  if (ch > 7) return;
  disableTCA();
  Wire.beginTransmission(tca_addr);
  Wire.write(1 << ch);
  Wire.endTransmission();
  delay(5);                  
}
`;
            ScratchBlocks.Arduino.setups_[i2c_startkey] = `Wire.begin(I2C_SDA0, I2C_SCL0);\n`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `${port}
Adafruit_BME680 bme(&Wire);

float readBME680(uint8_t type) {
  if (BME680_BUS == 0) {
    tcaSelect(TCA_ADDR, BME680_CHANNEL);
  } else {
    tcaSelect(TCA_ADDR_2, BME680_CHANNEL);
  }

  if (!bme.performReading()) {
    Serial.println("Lỗi đọc dữ liệu từ BME680 trong hàm readBME680!");
    return -999.0;
  }

  switch (type) {
    case 1:
      return bme.temperature;
    case 2:
      return bme.humidity;
    case 3:
      return bme.pressure / 100.0;
    case 4:
      return bme.gas_resistance / 1000;
    default:
      Serial.println("Type không hợp lệ! Phải là 1, 2, 3 hoặc 4.");
      return -999.0;
  }
}
`;
            ScratchBlocks.Arduino.setups_[startkey] = `
  if (BME680_BUS == 0) {
    tcaSelect(TCA_ADDR, BME680_CHANNEL);
  } else {
    tcaSelect(TCA_ADDR_2, BME680_CHANNEL);
  }

  // Khởi tạo BME680
  if (!bme.begin(0x77)) {
    Serial.println("Không tìm thấy BME680!");
    while (1);
  }

  bme.setTemperatureOversampling(BME680_OS_8X);
  bme.setHumidityOversampling(BME680_OS_2X);
  bme.setPressureOversampling(BME680_OS_4X);
  bme.setIIRFilterSize(BME680_FILTER_SIZE_3);
  bme.setGasHeater(320, 150);`;
        }
        return ``;
    };

    // esp32_BME680_temperature_value block
    ScratchBlocks.Arduino.esp32_BME680_temperature_value = function(block) {
        return [`readBME680(1)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_BME680_humidity_value block
    ScratchBlocks.Arduino.esp32_BME680_humidity_value = function(block) {
        return [`readBME680(2)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_BME680_pressure_value block
    ScratchBlocks.Arduino.esp32_BME680_pressure_value = function(block) {
        return [`readBME680(3)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_BME680_air_value block
    ScratchBlocks.Arduino.esp32_BME680_air_value = function(block) {
        return [`readBME680(4)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_BME680_read_value block
    ScratchBlocks.Arduino.esp32_BME680_read_value = function(block) {
        const value = block.getFieldValue('value');
        return `${value}\n`;
    };

    // esp32_WB2812_Led_start block
    ScratchBlocks.Arduino.esp32_WB2812_Led_start = function(block) {
        const startkey = 'esp32_WB2812_Led_startkey';    
        const Adafruit_NeoPixel_key = 'Adafruit_NeoPixel_key';
        const baurateKey = 'esp32_bauratekey';
        const port = block.getFieldValue('PORT');
        const num_leds = ScratchBlocks.Arduino.valueToCode(block, 'value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '72';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if(!ScratchBlocks.Arduino.includes_[Adafruit_NeoPixel_key]) {
            ScratchBlocks.Arduino.includes_[Adafruit_NeoPixel_key] = `#include <Adafruit_NeoPixel.h>`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `#define LED_PIN ${port}
#define LED_COUNT ${num_leds}

Adafruit_NeoPixel strip(
  LED_COUNT,
  LED_PIN,
  NEO_GRB + NEO_KHZ800
);

uint16_t baseHue = 0;

void rainbow() {
  for (int i = 0; i < LED_COUNT; i++) {
    uint16_t pixelHue = baseHue + (i * 65536L / LED_COUNT);
    strip.setPixelColor(i, strip.gamma32(strip.ColorHSV(pixelHue)));
  }
  strip.show();
  baseHue += 256;
  delay(1);
}
  
void drawRGBatPos(int pos, uint8_t r, uint8_t g, uint8_t b) {
  if (pos < 0 || pos >= strip.numPixels()) return;
  strip.setPixelColor(pos, r, g, b);
  strip.show();
}
  
void fillRGB(uint8_t r, uint8_t g, uint8_t b) {
  strip.fill(strip.Color(r, g, b));
  strip.show();
}
  
void drawHueAtPos(int pos, uint16_t hue, uint8_t sat = 255, uint8_t val = 255) {
  if (pos < 0 || pos >= strip.numPixels()) return;
  uint32_t color = strip.ColorHSV(hue, sat, val);
  strip.setPixelColor(pos, color);
  strip.show();
}

void fillHue(uint16_t hue, uint8_t sat = 255, uint8_t val = 255) {
  uint32_t color = strip.ColorHSV(hue, sat, val);
  strip.fill(color);
  strip.show();
}
  
void clear() {
  strip.clear();
  strip.show();
}
  
void clearAt(int pos) {
  if (pos < 0 || pos >= strip.numPixels()) return;
  strip.setPixelColor(pos, 0, 0, 0);
  strip.show();
}
  
void flashCurrentHue(int flashes, int flashDelay) {
  uint32_t currentColor = strip.ColorHSV(baseHue, 255, 255);  // màu hiện tại

  for (int i = 0; i < flashes; i++) {
    strip.fill(currentColor);
    strip.show();
    delay(flashDelay);
    
    clear();
    delay(flashDelay);
  }
}`;
            ScratchBlocks.Arduino.setups_[startkey] = `strip.begin();\n  strip.setBrightness(50);\n  strip.show();`;
        }
        return ``;
    };

    // esp32_WB2812_set_color block
    ScratchBlocks.Arduino.esp32_WB2812_set_color = function(block) {
        const position = ScratchBlocks.Arduino.valueToCode(block, 'position', ScratchBlocks.Arduino.ORDER_ATOMIC) || '0';
        const r = ScratchBlocks.Arduino.valueToCode(block, 'red', ScratchBlocks.Arduino.ORDER_ATOMIC) || '0';
        const g = ScratchBlocks.Arduino.valueToCode(block, 'green', ScratchBlocks.Arduino.ORDER_ATOMIC) || '255';
        const b = ScratchBlocks.Arduino.valueToCode(block, 'blue', ScratchBlocks.Arduino.ORDER_ATOMIC) || '255';
        return `drawRGBatPos(${position}, ${r}, ${g}, ${b});`;
    };

    // esp32_WB2812_effect block
    ScratchBlocks.Arduino.esp32_WB2812_effect = function(block) {
        const effect = block.getFieldValue('EFFECT');
        return effect+`\n`;
    };

    // esp32_Oled_start block
    ScratchBlocks.Arduino.esp32_Oled_start = function(block) {
        const startkey = 'esp32_Oled_startkey';    
        const Adafruit_SSD1306_key = 'Adafruit_SSD1306_key';
        const Adafruit_GFX_key = 'Adafruit_GFX_key';
        const baurateKey = 'esp32_bauratekey';
        const pin = block.getFieldValue('PORT');
        const wire_h_key = 'wire_h_key';
        const i2c_startkey = 'esp32_i2c_startkey';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if(!ScratchBlocks.Arduino.includes_[wire_h_key]) {
            ScratchBlocks.Arduino.includes_[wire_h_key] = `#include <Wire.h>`;
        }
        if(!ScratchBlocks.Arduino.includes_[Adafruit_SSD1306_key]) {
            ScratchBlocks.Arduino.includes_[Adafruit_SSD1306_key] = `#include <Adafruit_SSD1306.h>`;
        }
        if(!ScratchBlocks.Arduino.includes_[Adafruit_GFX_key]) {
            ScratchBlocks.Arduino.includes_[Adafruit_GFX_key] = `#include <Adafruit_GFX.h>`;
        }
        if (!ScratchBlocks.Arduino.definitions_[i2c_startkey]) {
            ScratchBlocks.Arduino.definitions_[i2c_startkey] = `
#define I2C_SDA0 13
#define I2C_SCL0 14
#define I2C_SDA1 15
#define I2C_SCL1 16

#define TCA_ADDR 0x70
void tcaSelect(TwoWire &i2c, uint8_t ch) {
  if (ch > 7) return;

  i2c.beginTransmission(TCA_ADDR);
  i2c.write(1 << ch);
  i2c.endTransmission();
}
`;
            ScratchBlocks.Arduino.setups_[i2c_startkey] = `Wire.begin(I2C_SDA0, I2C_SCL0);\n  Wire1.begin(I2C_SDA1, I2C_SCL1);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `${pin}
${Oled_start_code}
`;
            ScratchBlocks.Arduino.setups_[startkey] = `if (OLED_BUS == 0) {
  tcaSelect(Wire, OLED_CHANNEL);
  } else {
    tcaSelect(Wire1, OLED_CHANNEL);
  }

  if(!display.begin(SSD1306_SWITCHCAPVCC, 0x3C)) { 
    Serial.println(F("SSD1306 allocation failed"));
    for(;;);
  }

  display.clearDisplay();
  display.setTextColor(WHITE);`;
        }
        return ``;
    };
    
    // esp32_Oled_display block
    ScratchBlocks.Arduino.esp32_Oled_display = function(block) {
        const value = block.getFieldValue('value');
        return `showFace(${value});\n`;
    };

    // esp32_Servo_start block
    ScratchBlocks.Arduino.esp32_Servo_start = function(block) {
        const servo_start_key = 'esp32_Servo_startkey';
        const Servo_key = 'Servo_key';
        const baurateKey = 'esp32_bauratekey';
        const pin = block.getFieldValue('PORT');
        const startkey_pin = 'esp32_Servo_startkey_' + pin;
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if(!ScratchBlocks.Arduino.includes_[Servo_key]) {
            ScratchBlocks.Arduino.includes_[Servo_key] = `#include <ESP32Servo.h>`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey_pin]) {
            ScratchBlocks.Arduino.definitions_[startkey_pin] = `Servo servo${pin};\n#define SERVO${pin}_PIN ${pin}`;
            ScratchBlocks.Arduino.setups_[startkey_pin] = `servo${pin}.setPeriodHertz(50);\n  servo${pin}.attach(SERVO${pin}_PIN, 600, 2400);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[servo_start_key]) {
            ScratchBlocks.Arduino.definitions_[servo_start_key] = `void writeServo(Servo &sv, int angle) {\n  angle = constrain(angle, 0, 180);\n  sv.write(angle);\n}\n`;
        }
        return ``;
    };

    // esp32_Servo_set_angle block
    ScratchBlocks.Arduino.esp32_Servo_set_angle = function(block) {
        const pin = block.getFieldValue('PORT');
        const angle = ScratchBlocks.Arduino.valueToCode(block, 'angle', ScratchBlocks.Arduino.ORDER_ATOMIC) || '0';
        return `writeServo(servo${pin}, ${angle});\n`; 
    };

    // esp32_Motor_Start block
    ScratchBlocks.Arduino.esp32_Motor_Start = function(block) {
        const motor_start_key = 'esp32_Motor_startkey';
        const baurateKey = 'esp32_bauratekey';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[motor_start_key]) {
            ScratchBlocks.Arduino.definitions_[motor_start_key] = `#define IN1 5\n#define IN2 6\n#define IN3 15\n#define IN4 16
void motorA_forward(int speed) {  // speed 0-255
  ledcWrite(IN1, speed);
  ledcWrite(IN2, 0);
}

void motorA_backward(int speed) {
  ledcWrite(IN1, 0);
  ledcWrite(IN2, speed);
}

void motorA_stop() {
  ledcWrite(IN1, 0);
  ledcWrite(IN2, 0);
}

void motorB_forward(int speed) {
  ledcWrite(IN3, speed);
  ledcWrite(IN4, 0);
}

void motorB_backward(int speed) {
  ledcWrite(IN3, 0);
  ledcWrite(IN4, speed);
}

void motorB_stop() {
  ledcWrite(IN3, 0);
  ledcWrite(IN4, 0);
}

void forward(int speed) {
  motorA_forward(speed);
  motorB_forward(speed);
}

void backward(int speed){
  motorB_backward(speed);
  motorA_backward(speed);
}

void turnRight(int speed){
  motorA_forward(speed);
  motorB_backward(speed);
}

void turnLeft(int speed){
  motorA_backward(speed);
  motorB_forward(speed);
}

void stopAll() {
  motorA_stop();
  motorB_stop();
}\n`;
            ScratchBlocks.Arduino.setups_[motor_start_key] = `ledcAttach(IN1, 800, 8);
  ledcAttach(IN2, 800, 8);
  ledcAttach(IN3, 800, 8);
  ledcAttach(IN4, 800, 8);
  
  ledcWrite(IN1, 0);
  ledcWrite(IN2, 0);
  ledcWrite(IN3, 0);
  ledcWrite(IN4, 0);`;
        }
        return ``;
    };

    // esp32_motor_custom block
    ScratchBlocks.Arduino.esp32_motor_custom = function(block) {
        const motor = block.getFieldValue('motor');
        const mode = block.getFieldValue('mode');
        const speed = ScratchBlocks.Arduino.valueToCode(block, 'speed', ScratchBlocks.Arduino.ORDER_ATOMIC) || '150';
        return `motor${motor}_${mode}(${speed});\n`; 
    };

    // esp32_motor_back block
    ScratchBlocks.Arduino.esp32_motor_back = function(block) {
        const speed = ScratchBlocks.Arduino.valueToCode(block, 'speed', ScratchBlocks.Arduino.ORDER_ATOMIC) || '150';
        return `backward(${speed});\n`;
    };

    // esp32_motor_turn_right block
    ScratchBlocks.Arduino.esp32_motor_turn_right = function(block) {
        const speed = ScratchBlocks.Arduino.valueToCode(block, 'speed', ScratchBlocks.Arduino.ORDER_ATOMIC) || '150';
        return `turnRight(${speed});\n`;
    };

    // esp32_motor_turn_left block
    ScratchBlocks.Arduino.esp32_motor_turn_left = function(block) {
        const speed = ScratchBlocks.Arduino.valueToCode(block, 'speed', ScratchBlocks.Arduino.ORDER_ATOMIC) || '150';
        return `turnLeft(${speed});\n`;
    };

    // esp32_motor_forward block
    ScratchBlocks.Arduino.esp32_motor_forward = function(block) {
        const speed = ScratchBlocks.Arduino.valueToCode(block, 'speed', ScratchBlocks.Arduino.ORDER_ATOMIC) || '150';
        return `forward(${speed});\n`;
    };

    // esp32_motor_stop block
    ScratchBlocks.Arduino.esp32_motor_stop = function(block) {
        return `stopAll();\n`;
    };

    // esp32_button_start block
    ScratchBlocks.Arduino.esp32_button_start = function(block) {
        const startkey = 'esp32_button_startkey';
        const baurateKey = 'esp32_bauratekey';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `#define BUTTON_LEFT 7
#define BUTTON_RIGHT 8

unsigned long lastDebounceTime = 0;
char status_button = 0;
char Count_Button_7 = -1;
char Count_Button_8 = -1;
char Number_Button_7 = 0;
char Number_Button_8 = 0;
char Times_Button_7 = 0;
char Times_Button_8 = 0;

int button_debounce(int Pin_Button) {
  int reading = digitalRead(Pin_Button);

  if ((millis() - lastDebounceTime) > 200) {
    if (reading == LOW && status_button == 0) {  // LOW nghĩa là nhấn nút
      lastDebounceTime = millis();
      status_button = 1;
      return 1;  // Nhấn mới
    } else if (reading == HIGH) {
      status_button = 0;  // Reset khi thả nút
    }
  }

  return 0; // Không nhấn mới
}`;
            ScratchBlocks.Arduino.setups_[startkey] = `pinMode(BUTTON_LEFT, INPUT_PULLUP);\n  pinMode(BUTTON_RIGHT, INPUT_PULLUP);`;
        }
        return ``;
    };

    // esp32_right_button_value block
    ScratchBlocks.Arduino.esp32_right_button_value = function(block) {
        const value = ScratchBlocks.Arduino.valueToCode(block, 'button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return [`Times_Button_7 == 1 && Count_Button_7 == ${value}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_left_button_value block
    ScratchBlocks.Arduino.esp32_left_button_value = function(block) {
        const value = ScratchBlocks.Arduino.valueToCode(block, 'button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return [`Times_Button_8 == 1 && Count_Button_8 == ${value}`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_setting_toggle_button block
    ScratchBlocks.Arduino.esp32_setting_toggle_button = function(block) {
        const right_value = ScratchBlocks.Arduino.valueToCode(block, 'right_button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        const left_value = ScratchBlocks.Arduino.valueToCode(block, 'left_button_value', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"1"';
        return `  Number_Button_7 = ${right_value};
  if(Count_Button_7 == Number_Button_7){
    Count_Button_7 = 0;
  }
  Number_Button_8 = ${left_value};
  if(Count_Button_8 == Number_Button_8){
    Count_Button_8 = 0;
  }
  if(button_debounce(BUTTON_RIGHT) == 1){
    Count_Button_7++;;
    Times_Button_7 = 1;
  } else {
    Times_Button_7 = 0;
  }
  if(button_debounce(BUTTON_LEFT) == 1){
    Count_Button_8++;
    Times_Button_8 = 1;
  } else {
    Times_Button_8 = 0;
  }\n`;
    };

    // esp32_led_start block
    ScratchBlocks.Arduino.esp32_led_start = function(block) {
        const startkey = 'esp32_led_startkey';    
        const baurateKey = 'esp32_bauratekey';
        const pin = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `byte ledPin = ${pin};
float intsd;
`;
            ScratchBlocks.Arduino.setups_[startkey] = `pinMode(ledPin, OUTPUT);\n  digitalWrite(ledPin, LOW);`;
        }
        return ``;
    };

    // esp32_led_mode_on_pin block
    ScratchBlocks.Arduino.esp32_led_mode_on_pin = function(block) {
        const mode = block.getFieldValue('mode');
        return `analogWrite(ledPin,map(${mode},0,100,0,255));\n`;
    };

    // esp32_led_on_effect block
    ScratchBlocks.Arduino.esp32_led_on_effect = function(block) {
        const time = ScratchBlocks.Arduino.valueToCode(block, 'time', ScratchBlocks.Arduino.ORDER_ATOMIC) || '1';
        return `for (intsd = 1;intsd<=255;intsd = intsd + 25.5/(${time})) {
    analogWrite(ledPin, intsd);
    delay(100);
    if (intsd>=250) {
      break;
    }
  }\n`;
    };

    // esp32_led_off_effect block
    ScratchBlocks.Arduino.esp32_led_off_effect = function(block) {
        const time = ScratchBlocks.Arduino.valueToCode(block, 'time', ScratchBlocks.Arduino.ORDER_ATOMIC) || '1';
        return `for (intsd = 255;intsd>=0;intsd = intsd - 25.5/(${time})) {
    analogWrite(ledPin, intsd);
    delay(100);
    if (intsd<=5) {
      analogWrite(ledPin, 0);
      break;
    }
  }\n`;
    };

    // esp32_led_on_intensity block
    ScratchBlocks.Arduino.esp32_led_on_intensity = function(block) {
        const intensity = ScratchBlocks.Arduino.valueToCode(block, 'intensity', ScratchBlocks.Arduino.ORDER_ATOMIC) || '100';
        return `analogWrite(ledPin, map(${intensity},0,100,0,255));\n`;
    };

    // esp32_wifi block
    ScratchBlocks.Arduino.esp32_wifi = function(block) {
        const wifi_startkey = 'esp32_wifi_key';
        const baurateKey = 'esp32_bauratekey';
        const ssid = ScratchBlocks.Arduino.valueToCode(block, 'ssid', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"ESP32-Web"';
        const password = ScratchBlocks.Arduino.valueToCode(block, 'password', ScratchBlocks.Arduino.ORDER_ATOMIC) || '"12345678"';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if(!ScratchBlocks.Arduino.includes_[wifi_startkey]) {
            ScratchBlocks.Arduino.includes_[wifi_startkey] = `#include <WiFi.h>\n#include <ESPAsyncWebServer.h>`;
        }
        if (!ScratchBlocks.Arduino.definitions_[wifi_startkey]) {
            ScratchBlocks.Arduino.definitions_[wifi_startkey] = `const char* ssid = ${ssid};
const char* password = ${password};\n

AsyncWebServer server(80);

const char index_html[] PROGMEM = R"rawliteral(
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>ESP32 Robot Controller</title>
  <style>
    body {
      font-family: Arial;
      text-align: center;
      margin-top: 30px;
    }

    .controller {
      width: 200px;
      height: 200px;
      margin: 40px auto;
      position: relative;
    }

    .btn {
      position: absolute;
      width: 60px;
      height: 60px;
      font-size: 22px;
      border: none;
      background: #3498db;
      color: white;
      user-select: none;
      -webkit-user-select: none;
    }

    .btn:active {
      background: #1f618d;
    }

    .up {
      top: 0;
      left: 70px;
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    }

    .down {
      bottom: 0;
      left: 70px;
      clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
    }

    .left {
      left: 0;
      top: 70px;
      clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
    }

    .right {
      right: 0;
      top: 70px;
      clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
    }

    .ok {
      top: 70px;
      left: 70px;
      border-radius: 50%;
      background: #2ecc71;
      font-weight: bold;
    }
  </style>
</head>

<body>
  <h2>Send text to ESP32</h2>
  <input id="textInput" type="text" placeholder="Type something..." />
  <br><br>
  <button onclick="sendText()">Send</button>

  <h2>ESP32 Controller</h2>

  <div class="controller">
    <button class="btn up"
      onmousedown="startCmd('up')"
      onmouseup="stopCmd()"
      ontouchstart="startCmd('up')"
      ontouchend="stopCmd()">▲</button>

    <button class="btn down"
      onmousedown="startCmd('down')"
      onmouseup="stopCmd()"
      ontouchstart="startCmd('down')"
      ontouchend="stopCmd()">▼</button>

    <button class="btn left"
      onmousedown="startCmd('left')"
      onmouseup="stopCmd()"
      ontouchstart="startCmd('left')"
      ontouchend="stopCmd()">◀</button>

    <button class="btn right"
      onmousedown="startCmd('right')"
      onmouseup="stopCmd()"
      ontouchstart="startCmd('right')"
      ontouchend="stopCmd()">▶</button>

    <button class="btn ok"
      onclick="sendOnce('ok')">OK</button>
  </div>

  <script>
    function startCmd(cmd) {
      fetch("/send?msg=" + cmd + "_start");
    }

    function stopCmd() {
      fetch("/send?msg=stop");
    }

    function sendOnce(cmd) {
      fetch("/send?msg=" + cmd);
    }

    function sendText() {
      let text = document.getElementById("textInput").value;
      fetch("/send?input=" + encodeURIComponent(text));
    }
  </script>
</body>
</html>
)rawliteral";

String message = "";
String user_input = "";
`;
            ScratchBlocks.Arduino.setups_[wifi_startkey] = `WiFi.mode(WIFI_AP);
  WiFi.softAP(ssid, password);
  IPAddress IP = WiFi.softAPIP();
  Serial.println("WiFi AP started");
  Serial.print("Open browser at: http://");
  Serial.println(IP);
  
  server.on("/", HTTP_GET, [](AsyncWebServerRequest *request){
    request->send_P(200, "text/html", index_html);
  });
  
  server.on("/send", HTTP_GET, [](AsyncWebServerRequest *request){
    if (request->hasParam("msg")) {
      String msg = request->getParam("msg")->value();
      if(msg!= message) {
        message = msg;
      }
    }
    if (request->hasParam("input")) {
      String msg = request->getParam("input")->value();
      if(msg!= user_input) {
        user_input = msg;
      }
    }
    request->send(200, "text/plain", "OK");
  });

  server.begin();`;
        }
        return ``;
    };

    // esp32_button_clicked block
    ScratchBlocks.Arduino.esp32_button_clicked = function(block) {
        const button = block.getFieldValue('button_side');
        return [`message == "${button}"`, ScratchBlocks.Arduino.ORDER_EQUALITY];
    };

    // esp32_wifi_input block
    ScratchBlocks.Arduino.esp32_wifi_input = function(block) {
        return [`user_input`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_bluetooth_start block
    ScratchBlocks.Arduino.esp32_bluetooth_start = function(block) {
        const bluetooth_start_key = 'esp32_bluetooth_key';
        const baurateKey = 'esp32_bauratekey';
        const device_name = ScratchBlocks.Arduino.valueToCode(block, 'display_name', ScratchBlocks.Arduino.ORDER_ATOMIC) || 'ESP32S3-BLE';
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if(!ScratchBlocks.Arduino.includes_[bluetooth_start_key]) {
            ScratchBlocks.Arduino.includes_[bluetooth_start_key] = `#include <BLEDevice.h>\n#include <BLEServer.h>\n#include <BLEUtils.h>\n#include <BLE2902.h>`;
        }
        if (!ScratchBlocks.Arduino.definitions_[bluetooth_start_key]) {
            ScratchBlocks.Arduino.definitions_[bluetooth_start_key] = `BLECharacteristic *pCharacteristic;
bool deviceConnected = false;
String receivedValue = "";

// UUID tự đặt
#define SERVICE_UUID "12345678-1234-1234-1234-1234567890ab"
#define CHARACTERISTIC_UUID "abcd1234-5678-1234-5678-abcdef123456"

class MyServerCallbacks: public BLEServerCallbacks {
  void onConnect(BLEServer* pServer) {
    deviceConnected = true;
    Serial.println("📱 Device connected");
  }

  void onDisconnect(BLEServer* pServer) {
    deviceConnected = false;
    Serial.println("❌ Device disconnected");
    pServer->startAdvertising(); // Cho phép kết nối lại
  }
};

class MyCallbacks: public BLECharacteristicCallbacks {
  void onWrite(BLECharacteristic *pChar) {
    String value = pChar->getValue();

    if (value.length() > 0) {
      Serial.print("📩 Received: ");
      Serial.println(value);
      String reply = "ESP32 received: " + value;
      pChar->setValue(reply);
      pChar->notify();
    }
  }
};
`;
            ScratchBlocks.Arduino.setups_[bluetooth_start_key] = `BLEDevice::init(${device_name});
  BLEServer *pServer = BLEDevice::createServer();
  pServer->setCallbacks(new MyServerCallbacks());

  BLEService *pService = pServer->createService(SERVICE_UUID);

  pCharacteristic = pService->createCharacteristic(
                      CHARACTERISTIC_UUID,
                      BLECharacteristic::PROPERTY_READ   |
                      BLECharacteristic::PROPERTY_WRITE  |
                      BLECharacteristic::PROPERTY_NOTIFY
                    );

  pCharacteristic->addDescriptor(new BLE2902());
  pCharacteristic->setCallbacks(new MyCallbacks());

  pService->start();

  BLEAdvertising *pAdvertising = BLEDevice::getAdvertising();
  pAdvertising->start();`;
        }
        return ``;
    };

    // esp32_soil_moisture_start block
    ScratchBlocks.Arduino.esp32_soil_moisture_start = function(block) {
        const startkey = 'esp32_soil_moisture_startkey';    
        const baurateKey = 'esp32_bauratekey';
        const pin = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `#define MOISTURE_PIN ${pin}
#define DRY_VALUE 4095
#define WET_VALUE 1200`;
            ScratchBlocks.Arduino.setups_[startkey] = `analogReadResolution(12);\n  analogSetAttenuation(ADC_11db);`;
        }
        return ``;
    };

    // esp32_soil_moisture_value block
    ScratchBlocks.Arduino.esp32_soil_moisture_value = function(block) {
        return [`constrain(map(analogRead(MOISTURE_PIN), DRY_VALUE, WET_VALUE, 0, 100), 0, 100)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_temperature_artical_start block
    ScratchBlocks.Arduino.esp32_temperature_artical_start = function(block) {
        const startkey = 'esp32_temperature_artical_startkey';    
        const baurateKey = 'esp32_bauratekey';
        const pin = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `#include <OneWire.h>
#include <DallasTemperature.h>

#define oneWireBus ${pin}

OneWire oneWire(oneWireBus);
DallasTemperature sensors(&oneWire);

float temperature() {
  sensors.requestTemperatures();
  float temperatureC = sensors.getTempCByIndex(0);
  return temperatureC;
}`;
            ScratchBlocks.Arduino.setups_[startkey] = `sensors.begin();`;
        }
        return ``;
    };

    // esp32_temperature_artical_value block
    ScratchBlocks.Arduino.esp32_temperature_artical_value = function(block) {
        return [`temperature()`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };

    // esp32_light_sensor block
    ScratchBlocks.Arduino.esp32_light_sensor = function(block) {
        const startkey = 'esp32_light_sensor_startkey';
        const baurateKey = 'esp32_bauratekey';
        const pin = block.getFieldValue('PORT');
        if(!ScratchBlocks.Arduino.setups_[baurateKey]) {
            ScratchBlocks.Arduino.setups_[baurateKey] = `Serial.begin(115200);`;
        }
        if (!ScratchBlocks.Arduino.definitions_[startkey]) {
            ScratchBlocks.Arduino.definitions_[startkey] = `#define LIGHT_PIN ${pin}`;
            ScratchBlocks.Arduino.setups_[startkey] = `analogReadResolution(12);\n  analogSetPinAttenuation(LIGHT_PIN, ADC_11db);`;
        }
        return ``;
    };

    // esp32_light_sensor_value block
    ScratchBlocks.Arduino.esp32_light_sensor_value = function(block) {
        return [`map(analogRead(LIGHT_PIN), 0, 4095, 0, 100)`, ScratchBlocks.Arduino.ORDER_ATOMIC];
    };
};

export default defineDemoGenerators;
